module.exports = __webpack_public_path__ + "img/Einzeldiagnose_Rechnung_Taifun.4e333751.png";